function inview(){
	$(".inview").each(function(){
		var position = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll > position - windowHeight + windowHeight/3){
			$(this).addClass('is--inview');
		} else {
			//$(this).removeClass('is--inview');
		}
	});
}


module.exports = inview;


// WEBPACK FOOTER //
// ./es2015/module/inview.js